/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Cloudflare_Email_DescriptionInputs */

const en_admin_settings_groups_cloudflare_email_description = /** @type {(inputs: Admin_Settings_Groups_Cloudflare_Email_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Email Service`)
};

/**
* | output |
* | --- |
* | "Cloudflare Email Service" |
*
* @param {Admin_Settings_Groups_Cloudflare_Email_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_cloudflare_email_description = /** @type {((inputs?: Admin_Settings_Groups_Cloudflare_Email_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Cloudflare_Email_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_cloudflare_email_description(inputs)
});
export { admin_settings_groups_cloudflare_email_description as "admin.settings.groups.cloudflare_email.description" }